import { InputTestingComponent } from './../components/input-testing.component';
// workaround till context selection is provided from a different package.
// to get this configured as part of page configuration
import { NgModule } from '@angular/core';
import { PershingCoreModule } from '@pershing/pershing-core';
import { RouterModule } from '@angular/router';
import { PershingCommonModule } from '@pershing/pershing-common';
import { A11yModule } from '@angular/cdk/a11y'; // for cdkFocusInitial
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AddComponentComponent } from '../components/add-component.component';
import { PageLayoutComponent } from '../components/page-layout.component';
import { ComponentListService } from '../services/component-list.service';
import { PageLayoutService } from '../services/page-layout.service';
import { AddComponentDialog } from '../dialogs/add-component.dialog';
import { EditComponentComponent } from '../components/edit-component.component';
import { DeleteDialog } from '../dialogs/delete-dialog.component';
import { PageLayoutDialog } from '../dialogs/page-layout-dialog.component';

@NgModule({
    imports: [
        PershingCoreModule,
        PershingCommonModule,
        A11yModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatRadioModule,
        MatTooltipModule,
        RouterModule
    ],
    declarations: [
        AddComponentComponent,
        PageLayoutComponent,
        AddComponentDialog,
        EditComponentComponent,
        InputTestingComponent,
        DeleteDialog,
        PageLayoutDialog
    ],
    providers: [
        ComponentListService,
        PageLayoutService
    ],
    exports: [
        AddComponentComponent,
        PageLayoutComponent,
        AddComponentDialog,
        EditComponentComponent,
        InputTestingComponent,
        DeleteDialog,
        PageLayoutDialog
    ],
    entryComponents: [
        AddComponentComponent,
        PageLayoutComponent,
        AddComponentDialog,
        EditComponentComponent,
        InputTestingComponent,
        DeleteDialog,
        PageLayoutDialog
    ]
})
export class EditLibraryComponentModule { }
